import React from 'react'
import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
  } from '@chakra-ui/react'

function ProductVariant(props) {
    const objData= Object.assign([],props['data']);
  return (
        <TableContainer pt={10} pb={20}>
        <Table variant='striped'>
            <Thead>
            <Tr>
                <Th>Variant Name</Th>
                <Th>Variant Value</Th>
                </Tr>
            </Thead>
            <Tbody>
                {
                objData.map((item,index)=>(
                <Tr>
                <Td>{item.key}</Td>
                <Td>{item.value}</Td>
                </Tr>
                ))
                }
            </Tbody>
        </Table>
        </TableContainer>    
  )
}

export default ProductVariant